export const NATURALEZA = [
    "Contribuyente",
    "No Contribuyente",
]

export const TIPO_OPERACION = [
    "B2B",
    "B2C",
    "B2G",
    "B2F",
]

export const TIPO_CONTRIBUYENTE = [
    { label: "Sin selección", value: "" },
    { label: "Persona Física", value: "Persona Fisica" },
    { label: "Persona Jurídica", value: "Persona Juridica" },
];

export const TIPO_DOCUMENTO_FE = [
    { label: "Sin selección", value: "" },
    { label: "Cédula Paraguaya", value: "Cedula Paraguaya" },
    { label: "Pasaporte", value: "Pasaporte" },
    { label: "Cédula Extranjera", value: "Cedula Extranjera" },
    { label: "Carnet de Residencia", value: "Carnet de Residencia" },
    { label: "Innominado", value: "Innominado" },
    { label: "Tarjeta diplomática de exoneración Fiscal", value: "Tarjeta diplomatica de exoneracion Fiscal" },
    { label: "Otro Documento", value: "Otro Documento" },
];